import React from 'react';
import { TabbedForm, FormTab } from 'react-admin';
import DetailsTab from './Details';
import SuspectsTab from './Suspect';
import EvidenceTab from './Evidence';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    width: 'auto',
  },
});

const PlotTabs = ({
  hasCreate,
  hasEdit,
  hasList,
  hasShow,
  mutationMode,
  save,
  saving,
  ...props
}) => {
  const { resource } = props;
  const classes = useStyles();

  return (
    <TabbedForm {...props} toolbar={null}>
      <FormTab label={`resources.${resource}.tabs.details`}>
        <div className={classes.container}>
          <DetailsTab {...props} />
        </div>
      </FormTab>
      <FormTab label={`resources.${resource}.tabs.evidence`}>
        <EvidenceTab {...props} />
      </FormTab>
      <FormTab label={`resources.${resource}.tabs.suspects`}>
        <SuspectsTab {...props} />
      </FormTab>
    </TabbedForm>
  );
};

export default PlotTabs;
